import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Table } from "reactstrap";
import { Btn, H4, H6, Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service";
import { fetchPatientDocuments, uploadDocumentAPI } from "../../../Api/report";
import { toast } from "react-toastify";
interface PatientDocumentsProps {
  patientId: string;
  downloadDocument: (documentId: any) => void;
}

const PatientDocuments: React.FC<PatientDocumentsProps> = ({ downloadDocument, patientId = "" }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [documents, setDocuments] = useState<any>([]);

  const handleUploadClick = () => {
    fileInputRef.current?.click(); // trigger hidden file input
  };

  const loadDocuments = async () => {
    try {
      const docs = await fetchPatientDocuments(patientId);
      setDocuments(docs);
    } catch (err) {
      console.error("Error loading documents");
    }
  };


  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const formData = new FormData();

    // Append each file as 'file[]'
    Array.from(files).forEach((file) => {
      formData.append("file[]", file);
    });

    // Add patient ID to the form data
    formData.append("patientId", patientId);

    try {
      const response = await uploadDocumentAPI(formData);

      if (response?.data.status === "success") {
        toast.success("Documents uploaded")
        loadDocuments()
        // Optional: trigger refresh
      } else {
        toast.error("Upload failed ❌");
      }
    } catch (error) {
      alert("Error uploading file. Check console.");
      console.error(error);
    }
  };

  useEffect(() => {
    if (patientId) {
      loadDocuments();
    }
  }, [patientId]);

  return (
    <div className="dataTables_wrapper">
      <div className="header-top">
        <H4>Documents</H4>
        <Btn color="primary" onClick={handleUploadClick}>Upload Documents</Btn>
        <input
          type="file"
          ref={fileInputRef}
          multiple
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>
      <Row className="widget-grid">
        {documents?.map((document: any, key: any) => (
          <Col xl="3" className="p-2" key={key}>
            <Image className="img-fluid for-light" src={dynamicImage("logo/PDF.png")} alt="doc" width={160} />
            <div className="ps-2">{document.filename.split("__")[1]}</div>
          </Col>
        ))}
      </Row>
    </div>
  );
};


export default PatientDocuments;
